import { render, staticRenderFns } from "./guide-common.vue?vue&type=template&id=770bdf9c&scoped=true&"
import script from "./guide-common.vue?vue&type=script&lang=js&"
export * from "./guide-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770bdf9c",
  null
  
)

export default component.exports